import {CommonMessages} from '../common.messages';

export const PanelAccountsAddCashMessages = {
    GetAvailablePlatformsFailed: {
        key: 'GetAvailablePlatformsFailed',
        message: 'Error while communication with the server. Can\'t get the available portals.'
    },
    AvailablePlatformsNotFound: {
        key: 'AvailablePlatformsNotFound',
        message: 'Error while communication with the server. Can\'t find the available portals.'
    },
    GetTradingGroupsFailed: {
        key: 'GetTradingGroupsFailed',
        message: 'Error while communication with the server. Can\'t get trading groups.'
    },
    TradingActiveGroupsNotFound: {
        key: 'TradingActiveGroupsNotFound',
        message: 'Error while communication with the server. Can\'t find active client groups.'
    },
    ActiveTradingGroupsNotFound: {
        key: 'ActiveTradingGroupsNotFound',
        message: 'Error while communication with the server. Can\'t find active client groups.'
    },
    GetPortalsForTenantFailed: {
        key: 'GetPortalsForTenantFailed',
        message: 'Error while communication with the server. Can\'t find portals.'
    },
    GetPortalsForTenantInvalidData: {
        key: 'GetPortalsForTenantInvalidData',
        message: 'Error while processing the server request. Information about system portals is invalid.'
    },
    SameAccountSubType: {
        key: 'SameAccountSubType',
        message: 'The User already has cash account with this sub type.'
    },
    AccountRegistrationFailed: {
        key: 'AccountRegistrationFailed',
        message: 'Error while request to the server. Unable to register cash account.'
    },
    GetCurrenciesNotFound: {
        key: 'GetCurrenciesNotFound',
        message: 'Error while communication with the server. Can\'t find currencies.'
    },
    ...CommonMessages
};
